export const siteLangs = [
  { lable: "English", value: "en" },
  { lable: "Українська", value: "uk" },
  { lable: "Русский", value: "ru" },
];

export const emptyMultiLangStrings = [
  { text: "", language: "en" },
  { text: "", language: "ru" },
  { text: "", language: "uk" },
];
